module.exports = __webpack_public_path__ + "img/bit.1d57eae0.webp";